import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import {subdomainInfoURL} from "../../constants/api/endpoints";
import {backendBaseUrl} from "../../constants/api/backendBaseUrl";

export const useGetSubdomainInfo = () => {

  const handleRequest = async () => {
    const {data} = await axios.get(backendBaseUrl + subdomainInfoURL);
    return data;
  }

  return useQuery({
    queryKey: ['subdomain-info'],
    queryFn: handleRequest,
    retry: 1
  });
}